import React from 'react';
import styled from 'styled-components';
import commonIconStyles from './commonIconStyles';

const AddIcon = styled(props => (
  <svg
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0)"><path d="M23.67 3.77L16.367 0C15.614 1.086 13.946 1.844 12 1.844c-1.946 0-3.615-.758-4.368-1.844L.329 3.77a.642.642 0 00-.27.84l2.145 4.472c.15.309.51.434.807.281l2.122-1.082c.398-.203.863.098.863.563v9.906c0 .691.536 1.25 1.2 1.25h9.6c.663 0 1.2-.559 1.2-1.25V8.84c0-.461.465-.766.862-.563l2.123 1.082a.587.587 0 00.806-.28l2.149-4.47a.636.636 0 00-.267-.84z" /></g><defs><clipPath id="clip0"><path d="M0 0h24v20H0z" /></clipPath></defs>
  </svg>
))`
  ${commonIconStyles};
`;

export default AddIcon;
